import React, { useState} from "react";
import styles from "../../assets/css/newUser.module.scss";
import {Alert, Button, Grid, Snackbar} from "@mui/material";
import {useFormik} from "formik";
import {UserApi} from "../../../../utils/UserApi";
import * as yup from "yup";
import {IMaskInput} from "react-imask";
import {useNavigate} from "react-router-dom";
import {TextField} from "../../../../components/subComponents/TextField";
import LoadingButton from "../../../../components/subComponents/LoadingButton";

const MobileMask = React.forwardRef(function TextMaskCustom(props, ref) {
    const {onChange, ...other} = props;
    return (
        <IMaskInput
            {...other}
            mask="(#900) 000-0000"
            definitions={{
                '#': /[0]/,
            }}
            inputRef={ref}
            onAccept={(value) => onChange({target: {name: props.name, value}})}
            overwrite
        />
    );
});


const sleep = (ms) => new Promise((r) => setTimeout(r, ms));


const NewUser = props => {
    const [isInserting, setIsInserting] = useState(false);
    const [openSnackBar1, setOpenSnackBar1] = React.useState(false);
    const [message, setMessage] = useState('');
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };
    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };
    const navigate = useNavigate();


    const validationSchema = yup.object({
        mail: yup
            .string('پست الکترونیکی خود را وارد کنید')
            .email('پست الکترونیکی معتبر وارد کنید')
            .required('وارد کردن پست الکترونیکی اجباری ست.'),
        name: yup
            .string('رمز عبور خود را وارد کنید.')
            .required('وارد کردن نام الزامی ست.'),
        phone: yup
            .string('تلفن همراه را وارد کنید.')
            .required('وارد کردن تلفن همراه الزامی ست.'),
        password: yup
            .string('رمز عبور خود را وارد کنید.')
            // .min(8, 'Password should be of minimum 8 characters length')
            .required('وارد کردن رمز عبور الزامی ست.'),

    });


    const formik = useFormik({
        initialValues: {
            mail: '',
            name: '',
            phone: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const response = async (result) => {
                handleClickSnackBar1("کاربر افزوده شد.");
                await sleep(3000);
                navigate("/admin/users");
                formik.resetForm();
                setIsInserting(false);
            }
            const error = (e) => {

            }
            setIsInserting(true);

            let data={
                payload:{
                    name:values.name,
                    mail:values.mail,
                    phone:values.phone,
                    password:values.password
                }
            }
            await UserApi.insertNewUser(JSON.stringify(data), response, error);

        },
    });


    return <div className={`${styles.wrapper}`}>
        <form onSubmit={formik.handleSubmit} className={styles.container}>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <div className={styles.inputContainer}>
                        <TextField label="نام" variant="outlined"
                                   value={formik.values.name}
                                   onChange={formik.handleChange}
                                   fullWidth
                                   id="name"
                                   name="name"
                                   error={formik.touched.name && Boolean(formik.errors.name)}
                                   helperText={formik.touched.name && formik.errors.name}
                        />
                    </div>
                </Grid>


                <Grid item xs={12} md={6}>
                    <div className={styles.inputContainer}>

                        <TextField label="تلفن همراه" variant="outlined"
                                   className={`${styles.ltrTextField}`}

                                   value={formik.values.phone}
                                   onChange={formik.handleChange}
                                   InputProps={{
                                       inputComponent: MobileMask,
                                   }}
                                   fullWidth
                                   id="phone"
                                   name="phone"
                                   error={formik.touched.phone && Boolean(formik.errors.phone)}
                                   helperText={formik.touched.phone && formik.errors.phone}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} md={6}>
                    <div className={styles.inputContainer}>
                        <TextField label="پست الکترونیکی" variant="outlined"
                                   value={formik.values.mail}
                                   onChange={formik.handleChange}
                                   fullWidth
                                   id="mail"
                                   name="mail"
                                   error={formik.touched.mail && Boolean(formik.errors.mail)}
                                   helperText={formik.touched.mail && formik.errors.mail}
                                   className={`${styles.ltrTextField}`}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} md={6}>
                    <div className={styles.inputContainer}>
                        <TextField
                            fullWidth
                            id="password"
                            name="password"
                            label="رمز عبور"
                            type="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            variant="outlined"
                        />
                    </div>
                </Grid>
            </Grid>
            <Button color="error" onClick={() => {
                navigate(-1);
            }}>
                انصراف
            </Button>

            <LoadingButton
                loading={isInserting}
                loadingPosition="end"
                variant={'text'}
                color="primary"
                type={"submit"}
                component="button"

            >
                ثبت
            </LoadingButton>
        </form>

        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert onClose={handleCloseSnackBar1} severity="info"
                   action={null

                   }
                   className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>
    </div>;
};

export default NewUser;
